module.exports = __webpack_public_path__ + "img/buy-logo.76837ccb.png";